import React from "react";
import FilterList from "../../../../components/user/workingPart/workingPartUnitFilterList";
import Layout from "../../../../components/layouts/verticalLayout";

const WorkingPartUnitListPage = (props) => {
  return <Layout body={<FilterList />} />;
};

WorkingPartUnitListPage.propTypes = {};

export default WorkingPartUnitListPage;
